module.exports = __webpack_public_path__ + "img/stack_6.aeafd188.png";